import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const DeleteButton = styled.div`
  width: 25px;
  height: 25px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  background: #db2828;
  color: #fff;
  border: none;
  border-radius: 5px;
  text-transform: uppercase;
  &:hover {
    background: #d01919;
    border: 1px solid #000542;
  }
  @media (max-width: 992px) {
    width: 20px;
    height: 20px;
  }
`;

export const EditButton = styled(Link)`
  background: #fff;
  width: 25px;
  height: 25px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #fff;
  border: 1px solid #000542;
  border-radius: 5px;
  text-transform: uppercase;
  margin-right: 5px;
  &:hover {
    background: #17ade3;
    border: 1px solid #000542;
  }
  @media (max-width: 992px) {
    width: 20px;
    height: 20px;
  }
`;

export const Img = styled.img`
  width: 15px;
  height: 15px;
`;

export const ButtonBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
 
`;

export const SortBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  min-height: 75px;
`;
export const ColumnName = styled.div`
  display: flex;
  justify-content: center;
  font-size: 14px;
`;

export const ProductNameBlock = styled.div`
  width: 70%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0px auto;
`;

export const Label = styled.div`
  font-size: 16px;
  min-width: 150px;
`;

export const EmptyBlock = styled.div`
  min-width: 80px;
`;
export const LoaderBlock = styled.div`
  min-height: 80px;
`;

export const TagsGroup = styled.div`
  display: flex;
  justify-content: center;
  width: 70%;
  margin: 0 auto;
`;

export const NameBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const FooterBlock = styled.div`
  height: 50px;
`;

export const DishTitleLabel = styled.p`
  margin-right: 10px;
  margin-bottom: 0;
`;

export const ButtonGroupBlock = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto 10px;
  
`;

export const MealTagsBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
`;

export const DishCountBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px auto;
`;



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/DishListPage/DishListPageStyles.js